import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import DeposSupplierColumn from "../shared/component/dataTable/columns/DeposSupplierColumn.json";
import FormSection from "../shared/component/form/FormSection";
import DeposSupplierService from "../shared/service/DeposSupplierService";
import Translate from "../shared/language/Translate";
import {Button, Col, Label, Row} from "reactstrap";
import AvField from "../shared/component/form/AvField";
import GeneralUtils from "../shared/utils/GeneralUtils";
import {toast} from "react-toastify";
import ModalConfirm from "../shared/component/dialog/ModalConfirm";
import DataTablePaginationWithButton from "../shared/component/dataTable/DataTablePaginationWithButton";
import {Checkbox} from "primereact/checkbox";
import {PhoneField} from "../shared/component/form/PhoneField";
import Loading from "../shared/component/others/Loading";
import '../shared/styles/SettingsPage.css';

const defaultSupplier = {
    id: '',
    name: '',
    status: 'ACTIVE',
    email: '',
    phone: '',
    supplierAccountCode: '',
    vatNumber: '',
    postcode: '',
    includeTax: false,
    useInvoiceBarcode: true,
    deposSupplierBssId: null
};

export default class DeposSupplierList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            supplier: Object.assign({}, defaultSupplier),
            targetId: null,
            targetName: null,
            sourceId: null,
            sourceName: null,
            displayShowStatusConfirmDialog: false,
        }
        this.deposSupplierService = new DeposSupplierService();
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.refDataTable.refresh();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Depos Suppliers</h1>
                        </div>
                        <div className="settings-page__panel">
                            {this.productList()}
                        </div>
                    </div>
                    {this.state.loading && <Loading label="Processing, please wait..."/>}
                </AvForm>
            </div>
        );
    }

    productList() {

        var url = "product/depository/supplier/all";

        return (<div>
            <ModalConfirm header='Warning' ok='OK' onOkClick={this.mergeDeposSupplier}
                          onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                          show={this.state.displayShowStatusConfirmDialog}
                          message={this.state.noticeResponse}/>

            {this.renderDeposSupplierFields()}

            {this.renderMergeFields()}

            <FormSection>
                <div className="settings-page__table-wrap">
                    <DataTablePaginationWithButton ref={(elem) => this.refDataTable = elem}
                                                   fields={DeposSupplierColumn.fields}
                                                   objectName={DeposSupplierColumn.name}
                                                   dataURL={url}
                                                   view={this.view}
                                                   rows={10}
                                                   merge={this.merge}
                                                   selectionMode="single" onDataSelect={this.onDataSelect}
                                                   loading={this.state.loading}/>
                </div>
            </FormSection>


        </div>)
    };

    renderMergeFields() {
        return (<FormSection title={"Merge Depos Supplier"}><Row>

            <Col md="3">
                <AvGroup>
                    <Label for="itemSize">
                        <Translate contentKey="purchaseOrderItem.itemSize">Source Depos Supplier</Translate>
                        <span style={{color: 'red'}}> (*)</span>
                    </Label>
                    <AvField
                        type="text"
                        name="sourceName"
                        disabled={true}
                        className="form-control"
                        value={this.state.sourceName}
                        onChange={this.__handleChange}
                    />
                </AvGroup>
            </Col>
            <Col md="3">
                <AvGroup>
                    <Label for="itemSize">
                        <Translate contentKey="purchaseOrderItem.itemSize">Target Depos Supplier</Translate>
                        <span style={{color: 'red'}}> (*)</span>
                    </Label>
                    <AvField
                        type="text"
                        name="targetName"
                        disabled={true}
                        className="form-control"
                        value={this.state.targetName}
                        onChange={this.__handleChange}
                    />
                </AvGroup>
            </Col>



            <Col md="6">
                <div className="settings-page__actions" style={{borderTop: 'none', paddingTop: 0, marginTop: 0}}>
                    <Button color="outline-primary" className="settings-page__btn--merge"
                            onClick={() => {
                                this.showChangeStatusConfirmDialog()
                            }}>
                        <Translate contentKey="entity.action.add">Merge Supplier</Translate>
                    </Button>
                    <Button color="outline-primary" className="settings-page__btn--cancel"
                            onClick={() => {
                                this.setState({
                                    supplier: Object.assign({}, defaultSupplier),
                                    targetId: null,
                                    targetName: null,
                                    sourceId: null,
                                    sourceName: null,
                                    supplierDetailsSaveButtonRender: false
                                });
                            }}>
                        <Translate contentKey="entity.action.add">Clear</Translate>
                    </Button>
                </div>
            </Col>


        </Row>
        </FormSection>)
    }

    mergeDeposSupplier = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.sourceId) || GeneralUtils.isNullOrEmpty(this.state.targetId)) {
            return toast.warn("Please fill the required fields!");
        } else if (this.state.sourceId == this.state.targetId) {
            return toast.warn("Target Depos Supplier and Source Depos Supplier must be different! ");
        } else {
            this.setState({loading: true});
            this.deposSupplierService.mergeDeposSupplier(this.state.targetId, this.state.sourceId)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({targetId: null, targetName: null});
                        this.setState({sourceId: null, sourceName: null,loading:false});
                        this.refresh();
                    }
                });
        }
    }

    renderDeposSupplierFields() {
        return (<FormSection title={"Depos Supplier Detail"}>
            <Row>

                <Col md="3">
                    <AvGroup>
                        <Label for="tradingName">
                            <Translate contentKey="tax.tradingName">Name</Translate>
                            <span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="name"
                            disabled={!this.state.supplierDetailsSaveButtonRender}
                            validate={{
                                maxLength: {
                                    value: 255,
                                    errorMessage: "You can enter up to 255 characters in this field."
                                }
                            }}
                            value={this.state.supplier.name}
                            onChange={this.__handleChange}/>

                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="tradingName">
                            <Translate contentKey="tax.tradingName">Code</Translate>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="supplierAccountCode"
                            disabled={!this.state.supplierDetailsSaveButtonRender}
                            validate={{
                                maxLength: {
                                    value: 255,
                                    errorMessage: "You can enter up to 255 characters in this field."
                                }
                            }}
                            value={this.state.supplier.supplierAccountCode}
                            onChange={this.__handleChange}/>

                    </AvGroup>
                </Col>


                <Col md="3">
                    <AvGroup>
                        <Label for="emailAddress">
                            <Translate contentKey="merchantAccount.emailAddress">Email</Translate>
                        </Label>
                        <AvField
                            type="email"
                            className="form-control"
                            name="email"
                            disabled={!this.state.supplierDetailsSaveButtonRender}
                            validate={{
                                minLength: {
                                    "value": 5, "errorMessage": "Not Valid Email"
                                }, maxLength: {
                                    value: 255,
                                    errorMessage: "You can enter up to 255 characters in this field."
                                }
                            }}
                            value={this.state.supplier.email}
                            onChange={this.__handleChange}/>
                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="tradingName">
                            <Translate contentKey="tax.tradingName">Vat Number</Translate>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="vatNumber"
                            disabled={!this.state.supplierDetailsSaveButtonRender}
                            value={this.state.supplier.vatNumber}
                            onChange={this.__handleChange}/>

                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="tradingName">
                            <Translate contentKey="tax.tradingName">Postcode</Translate>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="postcode"
                            disabled={!this.state.supplierDetailsSaveButtonRender}
                            value={this.state.supplier.postcode}
                            onChange={this.__handleChange}/>

                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="mobilePhone">
                            <Translate contentKey="contactManagement.mobilePhone">
                                Phone</Translate>
                        </Label>
                        <PhoneField kind={'mobile'}
                                    disabled={!this.state.supplierDetailsSaveButtonRender}
                                    name="phone" errorMessage="Not Valid Phone Number"
                                    value={this.state.supplier.phone}
                                    onChange={this.__handleChange}
                        />
                    </AvGroup>
                </Col>

                <Col md="3">
                    <AvGroup>
                        <Label for="firstName">
                            <Translate contentKey="productfirstName">Inc VAT&nbsp;</Translate>
                        </Label>

                        <Checkbox onChange={(e) => this.setChecked("includeTax", e.checked)}
                                  name="includeTax"
                                  disabled={!this.state.supplierDetailsSaveButtonRender}
                                  value={this.state.supplier.includeTax}
                                  checked={this.state.supplier.includeTax}></Checkbox>


                    </AvGroup>
                </Col>
                <Col md="3">
                    <AvGroup>
                        <Label for="firstName">
                            <Translate contentKey="productfirstName">Use Invoice Barcode&nbsp;</Translate>
                        </Label>

                        <Checkbox onChange={(e) => this.setChecked("useInvoiceBarcode", e.checked)}
                                  name="useInvoiceBarcode"
                                  disabled={!this.state.supplierDetailsSaveButtonRender}
                                  value={this.state.supplier.useInvoiceBarcode}
                                  checked={this.state.supplier.useInvoiceBarcode}></Checkbox>


                    </AvGroup>
                </Col>


            </Row>
            {!GeneralUtils.isNullOrEmpty(this.state.supplier.id) &&
                <div className="settings-page__actions">
                    <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                        this.saveSupplier();
                    }}>
                        <Translate contentKey="entity.action.add">Update</Translate>
                    </Button>
                </div>
            }

       </FormSection>)
    }

    showChangeStatusConfirmDialog = () => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to merge these items?",
        });
    }
    merge = (data) => {
        this.setState({supplier: Object.assign({}, defaultSupplier), supplierDetailsSaveButtonRender: false});
        if (this.state.sourceId == null) {
            this.setState({sourceId: data.id, sourceName: data.name});
        } else {
            if (this.state.targetId == null) {
                this.setState({targetId: data.id, targetName: data.name});
            } else {
                return toast.warn("You can select up to two Depos Suppliers. To remove a selection, click the Clear button.");
            }
        }
    }

    onDataSelect = (rowData, event) => {
        // Eğer click event varsa ve button.function === "merge" ise return
        if (event && event.originalEvent) {
            const clickedElement = event.originalEvent.target;

            // Eğer merge button’una basıldıysa, onDataSelect çalışmasın
            if (clickedElement.closest('.pi-plus')) {
                return;
            }
        }

        // Diğer durumlarda çalıştır
        this.view(rowData); // row click action
    };


    view = (data) => {
        this.deposSupplierService.findById(data.id).then(response => {
            this.setState({
                supplier: Object.assign({}, response),
                supplierTemp: Object.assign({}, response),
                supplierDetailsSaveButtonRender: true
            });

        });
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    refreshDataTable = () => {
        this.refDataTable.refresh();
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let supplier = this.state.supplier;
        supplier[e.target.name] = value;
        this.setState({supplier: supplier});
    }

    setChecked = (name, value) => {
        let supplier = this.state.supplier;
        supplier[name] = value;
        this.setState({supplier: supplier});
    }

    saveSupplier = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.supplier.name)) {
            return toast.warn("Please fill the required fields!");
        } else {
            this.setState({loading: true});
            if (!GeneralUtils.isNullOrEmpty(this.state.supplier.id)) {
                this.deposSupplierService.update(this.state.supplier)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                supplierDetailsSaveButtonRender: false, supplier: Object.assign({}, defaultSupplier),
                                targetId: null,
                                targetName: null,
                                sourceId: null,
                                sourceName: null,
                                loading: false

                            });
                            this.refresh();
                        }
                    });
            } else {
                this.deposSupplierService.create(this.state.supplier)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                supplierDetailsSaveButtonRender: false, supplier: Object.assign({}, defaultSupplier),
                                targetId: null,
                                targetName: null,
                                sourceId: null,
                                sourceName: null,
                                loading: false

                            });
                            this.refresh();
                        }
                    });
            }
        }

    }

}

